export default __webpack_public_path__ + "static/media/parent_slide_student_two.d4b482f0.png";